export default class CollapsePanel {
  constructor() {
    this.toggleList = Array.from(document.querySelectorAll('[data-collapse]'));
    this.initHandlers();
  }

  initHandlers() {
    this.toggleList.forEach(toggle => {
      toggle.addEventListener('click', () => {
        const dropdown = document.getElementById(toggle.dataset.collapse);
        toggle.classList.toggle('icon-invert');
        dropdown.classList.toggle('collapse-panel--closed');
      });
    });
  }

  static setUp(options) {
    return new CollapsePanel(options);
  }
}
